import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../contexts/QuizContext';
import { PageContainer, ContentWrapper, Title, Subtitle, PrimaryButton } from '../styles/SharedComponents';

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const { resetQuiz } = useQuiz();

  useEffect(() => {
    // Resetar o quiz quando o usuário retorna à página inicial
    resetQuiz();
  }, [resetQuiz]);

  const handleStart = () => {
    navigate('/question/1');
  };

  return (
    <PageContainer>
      <ContentWrapper>
        <Title
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Descubra o Gateway de Pagamento Ideal
        </Title>
        <Subtitle
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Pare de perder dinheiro com o gateway errado! Escolher a solução certa
          pode fazer toda a diferença para o sucesso da sua operação. Responda algumas
          perguntas rápidas e descubra agora mesmo as melhores opções de gateway para você!
        </Subtitle>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <PrimaryButton onClick={handleStart}>Iniciar</PrimaryButton>
        </motion.div>
      </ContentWrapper>
    </PageContainer>
  );
};

export default Welcome; 